import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { listExtensions } from '../services/extension.service';
import { ExtensionUiLoader } from '../extensions/registry';

const ExtensionsPage = () => {
  const { name } = useParams();
  const navigate = useNavigate();
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await listExtensions();
        const items = res.data.data || [];
        setExtensions(items);
        if (!name && items.length > 0) {
          navigate(`/extensions/${items[0].name}`, { replace: true });
        }
      } catch (err) {
        setError('Failed to load extensions: ' + (err.response?.data?.error || err.message));
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Extensions</h1>

      {error && (
        <div className="mb-4 p-3 rounded text-sm bg-red-100 text-red-700">
          {error}
        </div>
      )}

      <div className="flex flex-col md:flex-row gap-6">
        <aside className="w-full md:w-64 flex-shrink-0">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
              <h2 className="font-medium text-gray-900">Installed Extensions</h2>
            </div>
            <ul className="divide-y divide-gray-100">
              {extensions.map((ext) => (
                <li key={ext.name}>
                  <button
                    type="button"
                    onClick={() => navigate(`/extensions/${ext.name}`)}
                    className={`w-full text-left px-4 py-3 text-sm transition-colors ${
                      name === ext.name
                        ? 'bg-blue-50 text-blue-700 font-medium'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <div className="font-medium">{ext.display_name || ext.name}</div>
                    <div className="text-xs text-gray-500">v{ext.version || '1.0.0'}</div>
                  </button>
                </li>
              ))}
              {extensions.length === 0 && (
                <li className="px-4 py-4 text-sm text-gray-500 text-center">
                  No extensions installed.
                </li>
              )}
            </ul>
          </div>
        </aside>

        <main className="flex-1 min-w-0">
          {name ? (
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <ExtensionUiLoader extensionName={name} />
            </div>
          ) : (
            <div className="bg-white rounded-lg border border-gray-200 p-8 text-center text-gray-500">
              Select an extension from the sidebar to configure it.
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default ExtensionsPage;
